/**
 * CON-8942 — Schedule of Named Insured (and other primary, non-premium-bearing
 * endorsements) must show their questions box on a renewal quote even when the
 * `HAS_ENDORSEMENT.included_in_excess` relationship flag was inherited as
 * `true` from the in-force policy.
 *
 * The previous gate also required `!includedInExcess`, which was wrong for the
 * primary-mode rendering: the `included_in_excess` flag refers to the excess
 * column and is irrelevant when deciding whether the primary-mode question
 * block should render. Renewals where that flag was `true` (because of the
 * default in `HasEndorsementInput.included_in_excess`) hid the entire box.
 *
 * Keeping this as a small pure helper so the visibility rule is explicit and
 * unit-testable.
 */
export interface PrimaryEndorsementQuestionsVisibilityInput {
  nonPremiumBearing: boolean | null | undefined;
  included: boolean | null | undefined;
  /**
   * Accepted in the input shape so callers can pass the relationship-level
   * flag verbatim, but intentionally ignored: it refers to the excess column
   * and is irrelevant when deciding whether the primary-mode question block
   * should render. See CON-8942.
   */
  includedInExcess?: boolean | null;
  questionCount: number;
}

export const shouldRenderPrimaryEndorsementQuestions = ({
  nonPremiumBearing,
  included,
  questionCount,
}: PrimaryEndorsementQuestionsVisibilityInput): boolean =>
  Boolean(nonPremiumBearing) && Boolean(included) && questionCount > 0;
